<div>
	<mat-icon>lock</mat-icon>

	<h1>Dear customer, due to unpaid invoice your license is now expired.</h1>

	<h2>Please contact Bridger team to reactivate your account once your debt is settled.</h2>

	<!-- <a mat-raised-button [routerLink]="[{ outlets: { modal: ['invoice-payment'] } }]" color="warn"> Pay Now </a> -->
</div>
